/*eslint-disable*/
import FeatherIcon from 'feather-icons-react';
import { useEffect, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import ProductCard from './ProductCard';

const ChatMessage = ({ chat, senderId, appId }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);
  const typingStartTimeRef = useRef(null);

  useEffect(() => {
    if (chat.sender !== 'customer') {
      const text = chat.text || '';
      typingStartTimeRef.current = Date.now();

      const tick = () => {
        const elapsed = Date.now() - typingStartTimeRef.current;
        const expectedIndex = Math.min(text.length, Math.floor(elapsed / 30));
        setDisplayedText(text.slice(0, expectedIndex));
        setCurrentIndex(expectedIndex);

        if (expectedIndex >= text.length) {
          clearInterval(typingInterval);
        }
      };

      const typingInterval = setInterval(tick, 30);

      // ট্যাব আবার visible হলে সাথে সাথে real elapsed time অনুযায়ী catch-up করে নেয়,
      // throttled interval tick-এর জন্য অপেক্ষা করে না
      const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          tick();
        }
      };
      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        clearInterval(typingInterval);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    } else {
      setDisplayedText(chat.text);
    }
  }, [chat.text, chat.sender]);

  // Slider navigation functions
  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -150,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: 150,
        behavior: 'smooth',
      });
    }
  };

  const PartialMarkdown = ({ content }) => {
    return (
      <ReactMarkdown
        components={{
          // Custom styling for markdown elements
          strong: ({ node, ...props }) => <strong style={{ fontWeight: '700' }} {...props} />,
          em: ({ node, ...props }) => <em style={{ fontStyle: 'italic' }} {...props} />,
          ul: ({ node, ...props }) => <ul style={{ paddingLeft: '20px', margin: '8px 0' }} {...props} />,
          li: ({ node, ...props }) => <li style={{ marginBottom: '4px' }} {...props} />,
          p: ({ node, ...props }) => <p style={{ margin: '6px 0' }} {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: chat.sender === 'customer' ? 'row-reverse' : 'row',
        marginBottom: chat.pending ? 0 : '15px',
      }}
    >
      <div
        style={{
          maxWidth: '100%',
          textAlign: chat.sender === 'customer' ? 'right' : 'left',
        }}
      >
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '5px',
            justifyContent: chat.sender === 'customer' ? 'flex-end' : 'flex-start',
          }}
        >
          <FeatherIcon icon={chat.sender === 'customer' ? 'user' : 'smartphone'} size={16} />
          <span style={{ fontWeight: '500', marginLeft: '5px' }}>
            {chat.sender === 'customer' ? 'User' : 'Assistant'}
          </span>
        </span>
        <div>
          {(chat.pending || displayedText) && (
            <p
              style={{
                backgroundColor: chat.pending ? 'transparent' : chat.sender === 'customer' ? '#cceeff' : '#f0f0f0',
                padding: chat.pending ? 0 : '10px 15px',
                lineHeight: chat.pending ? 0 : undefined,
                verticalAlign: chat.pending ? 'top' : undefined,
                borderRadius: '20px',
                fontWeight: 500,
                margin: 0,
                display: 'inline-block',
              }}
            >
              {chat.pending ? (
                <span role="status" aria-label="Processing your voice" aria-live="polite" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 0 }}>
                  <img src={require('../../static/img/animation/Animation.gif')} alt="" style={{ width: 72, height: 'auto', display: 'block', flexShrink: 0 }} />
                </span>
              ) : <PartialMarkdown content={displayedText} />}
            </p>
          )}
          <div style={{ marginTop: chat.pending ? 0 : '6px', alignContent: 'end' }}>
            {chat?.files?.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  gap: '5px',
                  marginBottom: '5px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-end',
                }}
              >
                {chat.files.map((base64String, index) => (
                  <div key={index} style={{ position: 'relative' }}>
                    <img
                      src={base64String}
                      alt="preview"
                      style={{ width: 100, height: 120, borderRadius: 4, objectFit: 'cover' }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Display product cards if images exist */}
          {chat?.images && chat?.images?.length > 0 && (
            <div style={{ position: 'relative', marginTop: '10px' }}>
              {/* Navigation Arrows */}
              <button
                onClick={scrollLeft}
                style={{
                  position: 'absolute',
                  left: '-10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 2,
                  backgroundColor: '#fff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                  e.currentTarget.style.borderColor = '#ccc';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#fff';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                }}
              >
                <FeatherIcon icon="chevron-left" size={16} color="#666" />
              </button>

              <button
                onClick={scrollRight}
                style={{
                  position: 'absolute',
                  right: '-10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 2,
                  backgroundColor: '#fff',
                  border: '1px solid #e0e0e0',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                  e.currentTarget.style.borderColor = '#ccc';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#fff';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                }}
              >
                <FeatherIcon icon="chevron-right" size={16} color="#666" />
              </button>

              {/* Slider Container */}
              <div
                ref={sliderRef}
                style={{
                  display: 'flex',
                  gap: '12px',
                  overflowX: 'auto',
                  scrollBehavior: 'smooth',
                  scrollSnapType: 'x mandatory',
                  paddingBottom: '4px',
                  // Hide scrollbar
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
                // Hide scrollbar for webkit browsers
                onLoad={(e) => {
                  const style = document.createElement('style');
                  style.textContent = `
                    .slider-container::-webkit-scrollbar {
                      display: none;
                    }
                  `;
                  document.head.appendChild(style);
                  e.target.classList.add('slider-container');
                }}
              >
                {chat.images.map((product, index) => (
                  <div
                    key={`${product.product_id}-${index}`}
                    style={{
                      scrollSnapAlign: 'start',
                      flexShrink: 0,
                    }}
                  >
                    <ProductCard product={product} senderId={senderId} appId={appId} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {!chat.pending && chat.timestamp && !Number.isNaN(new Date(chat.timestamp).getTime()) && (
          <div style={{ fontSize: '12px', color: '#999', marginTop: '5px' }}>
            {new Date(chat.timestamp).toLocaleString()}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
